import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import './style.css';

const Icon = ({ name, className, ...props }) => (
  <i className={`icon-${name} ${className || ''}`} {...props} />
);

export default styled(Icon)``;
